import React from 'react';
import PropTypes from 'prop-types';
import HttpRequest from '@Services/RequestFactory';
import externalUrl from '@Utils/ExternalUrl';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import MessageBroker from '@Services/MessageBroker';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';

const truncateAfter = 10;
const limitTo = 7;
const limitEnd = 2;

export default class ListOfAuthorsComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showAll: getValueByNs(this, 'props.citation.authors.length', 0) <= truncateAfter,
    };

    this.allAuthorsClick = this.allAuthorsClick.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  authorLinkClick(e, url) {
    e.preventDefault();
    const { onAuthorClick, citation } = this.props;

    onAuthorClick(citation);

    if (url) {
      const newWindow = window.open('', '_blank');

      MessageBroker.send({ url: HttpRequest.getUrlWithPrefix(url), method: 'GET' })
        .then((data) => {
          if (data)
            newWindow.location.href =
              window.s && window.s.visitor ? window.s.visitor.appendVisitorIDsTo(externalUrl(data)) : externalUrl(data);
        })
        .catch(Logger.error);
    }
  }

  allAuthorsClick(e) {
    e.preventDefault();

    this.setState({
      showAll: true,
    });
  }

  getAuthors() {
    const { citation } = this.props;
    const { showAll } = this.state;
    const authors = [...(citation.authors || [])];

    if (!showAll) {
      authors.splice(limitTo, authors.length - limitTo - limitEnd, { isShowMorePlaceholder: true });
    }

    return authors;
  }

  getTrackingProps() {
    const { metadata, citation } = this.props;

    if (!metadata.oldTrackingDisabled) {
      return {
        ...PrepareTrackingDataHelper.prepare(citation),
        'data-click-delegation': true,
        'data-tracking': 'true',
        'data-tracking-type': 'linkout',
        'data-tracking-action': 'author name',
        'data-tracking-context': 'reactions',
        'data-tracking-preview': getValueByNs(this.props, 'metadata.isViewPreview'),
      };
    }
    return {};
  }

  render() {
    return (
      <>
        {this.getAuthors().map((author, authorIndex, authors) =>
          author.isShowMorePlaceholder ? (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={authorIndex}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className="els-btn els-btn-link blue-compact els-btn-tiny els-btn-tiny-row e2e-more-authors-link"
                // eslint-disable-next-line no-script-url,react/jsx-no-script-url
                href="null"
                tabIndex="0"
                onClick={(e) => {
                  e.preventDefault();
                  this.allAuthorsClick();
                }}>
                (&hellip;)
              </a>{' '}
            </React.Fragment>
          ) : (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={authorIndex}>
              {author.link ? (
                <InnerHTML
                  tag="a"
                  className="els-btn els-btn-link blue-compact--underline els-btn-tiny els-btn-tiny-row e2e-author-link"
                  href="null"
                  onClick={(e) => {
                    e.preventDefault();
                    this.authorLinkClick(e, author.link);
                  }}
                  tabIndex="0"
                  {...this.getTrackingProps()}
                  html={author.author}
                />
              ) : (
                <InnerHTML tag="span" html={author.author} />
              )}
              {authorIndex < authors.length - 1 && '; '}
            </React.Fragment>
          )
        )}
      </>
    );
  }
}

ListOfAuthorsComponent.defaultProps = {
  onAuthorClick: () => null,
};

ListOfAuthorsComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  citation: PropTypes.object.isRequired,
  onAuthorClick: PropTypes.func,
};
